import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-readme',
  templateUrl: './readme.component.html',
  styleUrls: ['./readme.component.scss']
})
export class ReadmeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
